import Swal from "sweetalert2"
import { navigateToIndex } from "../common/function"
import * as API from "../services/httpService"
import {
  updateUiData
} from "../redux/actions"
// import withReactContent from "sweetalert2-react-content"

// const MySwal = withReactContent(Swal)

export function missingInfoAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not correct. Please check again. Thank you.",
  })
}

export function policyValidationAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not match our records. Please check again. Thank you.",
  })
}

export function largeUploadedFile() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Large file size is detected, we will automatically compress the file, and this may take a few minutes to complete. We appreciate your patience.",
  })
}

export function errorWhenUpload() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Error while processing, kindly delete and reupload the file. Thank you.",
  })
}

export function missingProvideDocumentProofOfClaimAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide document for proof of claim. Thank you.",
  })
}

export function pleaseAgreeAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please agree with the Terms & Conditions to proceed. Thank you.",
  })
}

export function fillPhysicianDetailAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for Physician. Please check again. Thank you.",
  })
}

export function fillPolicyDetailAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for Policy. Please check again. Thank you.",
  })
}

export function invalidCommenceDateAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please enter valid Policy Commencement Date. Please check again. Thank you.",
  })
}

export function pleaseAddPhysicianBeforeNext() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Please click add button to save Physician details before going to next page. Thank you.",
  })
}

export function pleaseAddOtherPoliciesBeforeNext() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Please click add button to save Other Policies before going to next page. Thank you.",
  })
}

export function insuredValidationAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "The Deceased details does not match our records. Please check again. Thank you.",
  })
}

export function missingSelectNatureOrOccurAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please select nature of death and death occur. Thank you.",
  })
}

const ClearDataWarning = Swal.mixin({
  customClass: {
    confirmButton: "swal-button--back",
    cancelButton: "swal-button--next",
    actions: "swal-footer",
  },
  buttonsStyling: false,
})

export function clearAllDataWarning(claimUploadListModel, folderName, dispatch) {
  ClearDataWarning.fire({
    title:
      "Are you sure you want to go back to the first page? This will be remove all the data you have entered.",
    //icon: "warning",
    scrollbarPadding: false,
    showCancelButton: true,
    confirmButtonColor: "#ff3333",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    focusConfirm: false,
  }).then(result => {
    if (result.value) {
      let deleteMultipleFileArray = []

      claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
        let deleteFileInfo = {}
        deleteFileInfo.fName = UploadedItem.fileName
        deleteFileInfo.folderName = folderName
        deleteMultipleFileArray.push(deleteFileInfo)
      })

      API.apiPostRequest(
        "/Claim/ClaimDocsMultipleDelete",
        deleteMultipleFileArray,
        null
      ).then(response => {
        dispatch(updateUiData("claimUploadListModel", []))
      })

      navigateToIndex()
    }
    return false
  })
}
